<script>
    import { apiURL } from '../../store.js'
    import Slider from './Slider.svelte'

    export let item
    export let color
</script>

<div class="labAtWork">
    {#if item.images.length === 1}
        <img src="{apiURL}{item.images[0].value.url}" alt={item.title} />
    {:else if item.images.length > 1}
        <Slider images={item.images} {color} title={item.title} />
    {/if}
    <div class="header">
        <div class="date">
            {item.date}
            —
        </div>
        <div class="title">
            {item.title}
        </div>
    </div>
    <div class="content">
        <p>{@html item.caption}</p>
    </div>
</div>

<style lang="scss">
    @import "../../styles/vars";

    .labAtWork {
        margin-top: 3rem;
    }

    img {
        max-width: 100%;
        margin-bottom: 10px;
    }

    .date {
        display: inline-block;
        font-family: "Work Sans";
        font-weight: 400;
        font-size: 0.85rem;
    }

    .title {
        display: inline-block;
        font-family: "Work Sans";
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.05rem;
        font-size: 0.85rem;
    }

    .content :global(p) {
        font-family: "Ysabeau";
        font-size: 1.3rem;
        margin-top: 0;
        margin-bottom: 2rem;
    }

    @include respond-to(phone) {
        .labAtWork {
            margin-top:0;
            margin-bottom: 3rem;
        }

        .content :global(p) {
            font-family: "Ysabeau";
            font-size: 1.08rem;
            line-height: 1.45rem;
            margin: 0 0 1rem 0;
        }
    }
</style>
